import { AuthHeading } from '@/bundle/Auth/ui/AuthHeading/AuthHeading';
import { MasterServiceAgreementWidget } from '@/bundle/shared/components/MasterServiceAgreement/MasterServiceAgreementWidget';
import { formatReactStringToHTMLString } from '@/bundle/shared/components/MasterServiceAgreement/const';
import { AcceptedAgreementDetails } from '@/bundle/shared/components/MasterServiceAgreement/AcceptedAgreementDetails/AcceptedAgreementDetails';
import { AuthLayout } from '@/bundle/Auth/ui/AuthLayout/AuthLayout';
import { Box } from '@/components/Box/Box';
import { useNavigate, useParams } from 'react-router';
import { NavigationLink } from '@/components/NavigationLink/NavigationLink';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/components/Notification/Notification';
import { getResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { FULL_MONTH_DATE_FORMAT, formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { getOrganizationMasterServiceAgreementDetails } from './api';

export const OrganizationMasterServiceAgreementPage = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const { data, isPending } = useQuery({
    queryKey: ['get_organization_master_service_agreement', id],
    queryFn: () => getOrganizationMasterServiceAgreementDetails(id),
  });

  const masterServiceAgreementDetails = data?.body;
  const modifiedDate = formatDate(masterServiceAgreementDetails?.agreement?.date_version, FULL_MONTH_DATE_FORMAT);
  const error = getResponseError(data?.error);
  const header = `MSA with ${masterServiceAgreementDetails?.organization_name}`;

  return (
    <AuthLayout position='top' isLoading={isPending}>
      <AuthHeading
        header='Master Service Agreement'
        subHeader='This page provides a record of the accepted Master Service Agreement.'
      />
      {error && <Notification variant='error'>{error}</Notification>}

      {masterServiceAgreementDetails && (
        <MasterServiceAgreementWidget
          header={header}
          modifiedDate={modifiedDate}
          actionSlot={<AcceptedAgreementDetails details={masterServiceAgreementDetails} modifiedDate={modifiedDate} />}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: formatReactStringToHTMLString(masterServiceAgreementDetails?.agreement?.agreement_html),
            }}
          />
        </MasterServiceAgreementWidget>
      )}

      <Box marginTop='42px'>
        <NavigationLink to={''} onClick={() => navigate(-1)}>
          {'< Return to Organization Details'}
        </NavigationLink>
      </Box>
    </AuthLayout>
  );
};
